import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface ModalProps {
    children: React.ReactNode;
    onClose: () => void;
    title?: string;
}


const Modal = ({ children, onClose, title }: ModalProps) => {
    const { t } = useTranslation('common');

    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="relative bg-white max-h-[95vh] w-full max-w-[90vw] overflow-hidden rounded-xl shadow-lg p-8">
                {title && (
                    <div className="mb-4 border-b pb-2">
                        <h2 className="text-2xl font-semibold text-gray-900">{title}</h2>
                    </div>
                )}

                <div className="overflow-auto max-h-[80vh]">
                    {children}
                </div>

                <div className="sticky bottom-0 bg-white mt-4 pt-4 text-right">
                    <button
                        className="ml-auto flex items-center justify-center gap-2 rounded-xl bg-gray-50 px-4 py-2 text-sm text-gray-800 border border-gray-300 hover:bg-gray-100 shadow-sm transition"
                        onClick={onClose} >
                        {t("close")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
